module.exports = __webpack_public_path__ + "img/bmart-nor-42@2x.1deb35b8.png";